<template>
	<div class="w-100 bg-white border rounded-6">
  	<div class="mb-4 p-4 border-bottom-2" :class="{'text-center':is_mobile}">
  		<div class="row">
  			<div :class="is_mobile?'col-12 mb-3':'col-6'">
  				<p class="body-2-2 font-bold mb-0" :class="is_mobile?'text-16':'text-18 text-black'">{{tx_payment.payment_method.name}}</p>
  				<div class="w-100">
	  				<img v-if="tx_payment.use_guestpro_pg" src="../../../assets/img/icon/payment/CC2.jpg" height="38">
	  				<img v-else src="../../../assets/img/icon/payment/CC.jpg" height="38">
  				</div>
  			</div>
  			<div :class="is_mobile?'col-12':'col-6 text-right'">
  				<p class="mb-0" :class="is_mobile?'body-3-1':'body-2-1'">{{$t('payment-result.payment-time')}}</p>
  				<p class="mb-0 text-orange" :class="is_mobile?'heading-6-1':'heading-5-1'">
	  				<template v-if="countdown.hours() < 10">
							0{{countdown.hours()}}:
						</template>
						<template v-else>
							{{countdown.hours()}}:
						</template>
						<template v-if="countdown.minutes() < 10">
							0{{countdown.minutes()}}:
						</template>
						<template v-else>
							{{countdown.minutes()}}:
						</template>
						<template v-if="countdown.seconds() < 10">
							0{{countdown.seconds()}}
						</template>
						<template v-else>
							{{countdown.seconds()}}
						</template>
					</p>
  			</div>
  		</div>
  	</div>
		
		<!-- FORM -->
  	<div class="px-4 pb-4">
  		<div class="row">

				<!-- FIRST NAME -->
  			<div class="col-12 col-xl-6 mb-4 position-relative">
  				<p class="mb-1" :class="is_mobile?'body-3-1':'body-2-1'">First Name</p>
          <input
            type="text"
            class="ls-1-5 form-control body-2-2 text-14 mb-1 font-semibold pl-5"
						v-model="form.first_name"
						:class="{'error':error.first_name != ''}"
             />
          <i class="simple-icon-user position-absolute text-16" style="left:28px; top:39px;"></i>
           <p class="mb-0 text-danger body-2 text-12 font-regular delay" v-if="error.first_name != ''">{{error.first_name}}</p>
  			</div>

				<!-- LAST NAME -->
  			<div class="col-12 col-xl-6 mb-4 position-relative">
  				<p class="mb-1" :class="is_mobile?'body-3-1':'body-2-1'">Last Name</p>
          <input
            type="text"
            class="ls-1-5 form-control body-2-2 text-14 mb-1 font-semibold pl-5"
						v-model="form.last_name"
						:class="{'error':error.last_name != ''}"
             />
          <i class="simple-icon-user position-absolute text-16" style="left:28px; top:39px;"></i>
           <p class="mb-0 text-danger body-2 text-12 font-regular delay" v-if="error.last_name != ''">{{error.last_name}}</p>
  			</div>

				<!-- EMAIL -->
  			<div class="col-12 col-xl-6 mb-4 position-relative">
  				<p class="mb-1" :class="is_mobile?'body-3-1':'body-2-1'">Email</p>
          <input
            type="text"
            class="ls-1-5 form-control body-2-2 text-14 mb-1 font-semibold pl-5"
						v-model="form.email"
						:class="{'error':error.email != ''}"
             />
          <i class="simple-icon-envelope position-absolute text-16" style="left:28px; top:39px;"></i>
           <p class="mb-0 text-danger body-2 text-12 font-regular delay" v-if="error.email != ''">{{error.email}}</p>
  			</div>

				<!-- PHONE NUMBER -->
  			<div class="col-12 col-xl-6 mb-4 position-relative">
  				<p class="mb-1" :class="is_mobile?'body-3-1':'body-2-1'">Phone Number</p>
          <input
            type="text"
            class="ls-1-5 form-control body-2-2 text-14 mb-1 font-semibold pl-5"
						v-model="form.phone_number"
						:class="{'error':error.phone_number != ''}"
             />
          <i class="simple-icon-phone position-absolute text-16" style="left:28px; top:39px;"></i>
           <p class="mb-0 text-danger body-2 text-12 font-regular delay" v-if="error.phone_number != ''">{{error.phone_number}}</p>
  			</div>
				
				<div class="col-12 mb-4">
					<div class="w-100 border-t-form"></div>
				</div>
				
				<!-- CARD NUMBER -->
  			<div class="col-12  col-xl-6 mb-4 position-relative">
  				<p class="mb-1" :class="is_mobile?'body-3-1':'body-2-1'">Card Number</p>
          <input
            type="text"
            v-model="form.card_number"
            class="ls-1-5 form-control body-2-2 text-14 mb-1 font-semibold pl-5"
            data-inputmask="'mask': '9999 9999 9999 9999','greedy' : false"
            placeholder="0000 0000 0000 0000"
            :class="{'error':error.card_number != ''}"
             />
          <i class="simple-icon-credit-card position-absolute text-16" style="left:28px; top:39px;"></i>
           <p class="mb-0 text-danger body-2 text-12 font-regular delay" v-if="error.card_number != ''">{{error.card_number}}</p>
  			</div>
				
				<!-- EXPIRY DATE -->
  			<div class="col-sm-6 col-12 col-xl-3  mb-4 position-relative">
  				<p class="mb-1" :class="is_mobile?'body-3-1':'body-2-1'">Expiry Date</p>
          <input 
            type="text" 
            v-model="form.exp_date"
            data-inputmask="'mask': '99/9999','greedy' : false"
            class="ls-1-5 form-control body-2-2 text-14 mb-1 font-semibold pl-5"
            placeholder="MM/YYYY" 
            :class="{'error':error.exp_date != ''}"
             />
            <i class="simple-icon-calendar position-absolute text-16" style="left:28px; top:39px;"></i>
            <p class="mb-0 text-danger body-2 text-12 font-regular delay" v-if="error.exp_date != ''">{{error.exp_date}}</p>
  			</div>

				<!-- CVV -->
  			<div class="col-sm-6 col-12 col-xl-3  mb-4 position-relative">
  				<p class="mb-1" :class="is_mobile?'body-3-1':'body-2-1'">CVV</p>
          <input 
            type="password" 
            v-model="form.cvv"
            maxlength="4"
            class="form-control body-2-2 text-14 mb-1 font-semibold pl-5"
            placeholder="***" 
            @input="validateFormCopas('cvv')"
            :class="{'error':error.cvv != ''}"
             />
           	<i class="simple-icon-lock position-absolute text-20" style="left:28px; top:38px;"></i>
            <p class="mb-0 text-danger body-2 text-12 font-regular delay" v-if="error.cvv != ''">{{error.cvv}}</p>
  			</div>

				<!-- ERROR MESSAGE  -->
  			<div class="col-12 mb-4" v-if="Object.keys(push.error).length > 0 || cancel.error != ''">
  				<div class="px-3 py-2 border radius-0 text-center d-block mb-3" style="background-color: rgb(255, 246, 243); border-color: rgb(254, 207, 184) !important;">
  					<template v-if="Object.keys(push.error).length > 0">
  						<p class="mb-1 body-2-1 mx-auto font-weight-bold">{{push.error.error_code}}</p>
					    <p class="mb-0 body-2-1 mx-auto">{{push.error.message}}</p>
					    <p v-if="push.error.xendit_code" class="mb-0 body-2-4 mx-auto">ERROR CODE : {{push.error.xendit_code}}</p>
					    <p class="mb-0 body-3-1 mx-auto">Please try again</p>
  					</template>
					  <p v-else class="mb-0 body-2-1 mx-auto">{{cancel.error}}</p>
				  </div>
  			</div>

				<!-- BUTTON -->
  			<div class="col-12">
  				<button
  					v-if="!is_mobile"
  					class="button-black d-inline-block align-middle py-3 px-5 mr-3" 
  					:disabled="cancel.loading || push.loading"
  					:class="{'button-disabled':cancel.loading || push.loading}"
  					@click="cancelForm()">
  					<pulse-loader v-if="cancel.loading" color="#222"></pulse-loader>
						<p class="mb-0" v-else>Cancel</p>
  				</button>
  				<button 
  					class="btn bg-orange py-3 px-5" 
  					:disabled="push.loading || cancel.loading"
  					:class="{
  						'button-disabled':push.loading || cancel.loading,
  						'w-100 mb-3': is_mobile,
  						'd-inline-block align-middle':!is_mobile}"
  					@click="submitForm()">
  					<pulse-loader :loading="push.loading" color="#fff" v-if="push.loading"></pulse-loader>
						<p class="body-2-4 mb-0 text-white" v-else>Pay Now</p>
  				</button>
  				<button
  					v-if="is_mobile"
  					class="button-black w-100 py-3 px-5" 
  					:disabled="cancel.loading || push.loading"
  					:class="{'button-disabled':cancel.loading || push.loading}"
  					@click="cancelForm()">
  					<pulse-loader v-if="cancel.loading" color="#222"></pulse-loader>
						<p class="mb-0" v-else>Cancel</p>
  				</button>
  			</div>
  		</div>		
  	</div>

		<div class="box-warning background-warning" v-show="push.is_otp">
	    <div class="position-relative" >
	      <div class="row no-gutters justify-content-center">
	        <div class="fixed-top d-block nav-bottom">
	          <div class="custom-container-fluid px-0">
	            <div class="row justify-content-center no-gutters">
	              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
	                <div class="hide-scroll overflow-scroll">
	                  <div class="w-100">
	                    <div class="mt-12">
	                      <div class="p-3">
		                      <div class="w-100 bg-white rounded">
		 	                    	<iframe id="sample-inline-frame" name="sample-inline-frame" style="width: 100% !important;height:450px !important;"> </iframe>
		                      </div>
	                      </div>
	                    </div>
	                  </div>
	                </div>
	              </div>
	            </div>
	          </div>
	        </div>
	      </div>
	    </div>
	  </div>

		<!-- POPUP IF EXPIRED -->
		<popup-detail 
				id_ref="success_trx"
	    	direction="bottom" 
	    	:show="show_popup_expired"
	    	use_max_size
	    	wrapper_size="mobile"
	    	use_footer
	    	no_close_backdrop
	    	@close="toggleExpired">
	    	<template v-slot:body>
	    		<div class="py-5 px-4 text-center">
	    			<div class="rounded-100 my-2 w-20 mx-auto">
              <div class="bg-danger rounded-100 mx-auto size-icon-in">
                <img src="../../../assets/img/icon/close-white.png" width="40" style="margin: 20px 20px">
              </div>
            </div>
		    		<p class="mb-0 body-2-2 text-18 text-green font-extrabold">Expired</p>
            <p class="mb-2 body-2-2">Your payment period has expired, your transaction will be automatically canceled.</p>
		    	</div>
	    	</template>
	    	<template v-slot:footer>
		    	<div class="px-3 pt-3">
		    		<router-link :to="`/${getMerchant().code}/booking`">
	            <button 
								class="ga-btn-primary-lg" >
								Order Again
							</button>
	          </router-link>
					</div>
		    </template>
	    </popup-detail>
	</div>
</template>
<script type="text/javascript">
	import Inputmask from "inputmask";
	import 'inputmask/dist/inputmask.min.js';
	import 'inputmask/dist/bindings/inputmask.binding.js';
  import config from '@/config/index.js';
  import {post} from '@/services/index.js';
  import {mapGetters,mapMutations} from 'vuex';
  import moment from 'moment'
	import { validationMixin } from "vuelidate";
	const { email, required } = require("vuelidate/lib/validators");

	// OFFICIAL REGEX FROM XENDIT /^\+[1-9]\d{1,14}$/
	const validatePhoneForm = (value) => {
		const phoneRegex = /^\+[1-9]\d{1,14}$/;
		return phoneRegex.test(value);
	}

	export default{
		props:{
			tx_payment:{
				type: Object,
				default: () => {}
			},
			module_page:{
				type: String,
				default: 'BOOKING_ENGINE'
			},
			submodule_page:{
				type: String,
				default: ''
			}
		},
		data(){
			return{
				form:{
					card_number: '',
					exp_date: '',
					cvv: '',
					first_name: '',
					last_name: '',
					email: '',
					phone_number: ''
				},
				error:{
					card_number: '',
					exp_date: '',
					cvv: '',
					first_name: '',
					last_name: '',
					email: '',
					phone_number: ''
				},
				push:{
					loading: false,
					error: {},
					is_otp: false
				},
				cancel:{
					loading: false,
					error: ''
				},
				countdown: moment(),
	      timeout: false,
	      is_mobile: true,
				show_popup_expired: false
			}
		},
		mixins: [validationMixin],
    validations: {
      form:{
        first_name:{
          required
        },
				last_name:{
          required
        },
				email:{
          required, email
        },
				phone_number:{
          required, validatePhoneForm
        },
      }
    },
		computed:{
			is_expired_trx(){
				let now = moment().toDate()
				let exp_date = moment.utc(this.tx_payment.created_at).local().add(this.tx_payment.duration,'h').toDate()
				return moment(now).isAfter(exp_date) ? true : false
			},
			is_international(){
				return this.tx_payment && this.tx_payment.payment_method.bank_name == 'XENDIT_INTERNATIONAL' ? true : false
			}
		},
		created(){
			if (window.innerWidth > 768) {
				this.is_mobile = false
			}
		},
		mounted(){
      let externalScript = document.createElement('script')
			let final_url = this.is_international ?  config.XENDIT_NEW_URL : config.XENDIT_URL
      externalScript.setAttribute('src', final_url)
      document.head.appendChild(externalScript)

			$(document).ready(function(){
			  Inputmask().mask(document.querySelectorAll("input"));
			});
			this.validateAutoCancel()
			this.fillUserData()
		},
		methods:{
			...mapGetters(['getMerchant']),
			...mapMutations(['setBeTxPayment']),
			formatTime(date){
				return moment(date).format("HH:mm")
			},
			toggleExpired(){
				this.show_popup_expired = !this.show_popup_expired
			},
			fillUserData(){
        const { customer_details={}, customer={} } = this.tx_payment
				const { first_name = '', given_names= '', surname= '', last_name = '', email = '', phone_number = '' } = this.$deepCopy(this.$isEmpty(customer_details) ? customer : customer_details);
				Object.assign(this.form, { 
          first_name: this.$isEmpty(first_name) ? given_names : first_name , 
          last_name: this.$isEmpty(last_name) ? surname : last_name, 
          email, phone_number });
			},
			validateAutoCancel(){
				if(this.is_expired_trx){
					if(this.module_page == 'BOOKING_ENGINE'){
						this.setBeTxPayment({})
					}
					this.$emit("expired")
				}else{
					let now = moment().toDate()
					let exp_date = moment.utc(this.tx_payment.created_at).local().add(this.tx_payment.duration,'h').toDate()
		      let now_formatted = moment(now).format("YYYY-MM-DD HH:mm:ss")
		      let expired_at_formatted = moment(exp_date).format("YYYY-MM-DD HH:mm:ss")
		      this.countdown = moment.duration(moment(expired_at_formatted).diff(moment(now_formatted)))

		      let looping = setInterval(() => {
		          this.countdown = this.countdown.subtract(1, 'seconds')
		        if (this.countdown.hours() <= 0 && this.countdown.minutes() <= 0 && this.countdown.seconds() <= 0) {
		          clearInterval(looping)
		          this.timeout = true
		        }
		      },1000)
				}
			},
			validateFormCopas(field){
				this.form[field] = this.form[field].replace(/\D/g,'')
			},
			validateForm(){
				// FIRST/LAST NAME & PHONE NUMBER 
				this.error.first_name = this.$v.form.first_name.$invalid ? 'First name is required' : '' 
				this.error.last_name = this.$v.form.last_name.$invalid ? 'Last name is required' : '' 

				// EMAIL
				if(this.$v.form.email.$invalid) this.error.email = !this.$v.form.email.required ? 'Email is required' : 'Email is invalid'
				else this.error.email = ''

				// PHONE NUMBER
				if(this.$v.form.phone_number.$invalid) this.error.phone_number = !this.$v.form.phone_number.required ? 'Phone number is required' : 'Phone number is invalid'
				else this.error.phone_number = ''
				
				// CARD NUMBER
				if(this.form.card_number == '')this.error.card_number = 'Card number is required'
				else{
					let cn = this.form.card_number.replace(/\D/g,'')

					if(cn.length < 15) this.error.card_number = 'Card number cannot be less than 15 characters'
					else{
						if(this.is_international) this.error.card_number = ''
						else{
							if(!Xendit.card.validateCardNumber(cn)) this.error.card_number = 'Invalid card number'
							else this.error.card_number = ''
						}
					}
				}

				// EXP DATE
				if(this.form.exp_date == '') this.error.exp_date = 'Expiry date is required' 
				else {
					let ed = this.form.exp_date.replace(/\D/g,'')
					
					if(ed.length < 6) this.error.exp_date = 'Invalid expiry date'
					else{
						if(this.is_international) this.error.exp_date = ''
						else{
							let ed_s = this.form.exp_date.split("/")
							if(Xendit.card.validateExpiry(ed_s[0],ed_s[1])) this.error.exp_date = ''
							else this.error.exp_date = 'Invalid expiry date'
						}
					}
				}

				// CVV
				if(this.form.cvv == '') this.error.cvv = 'CVV is required'
				else if(this.form.cvv.length < 3) this.error.cvv = 'Invalid CVV'
				else{
					if(this.is_international) this.error.exp_date = ''
					else{
						if(Xendit.card.validateCvn(this.form.cvv)) this.error.cvv = '' 
						else this.error.cvv = 'Invalid CVV'
					}
				}

				let is_valid = Object.keys(this.error).every(key => this.error[key] === '');

				return is_valid
			},
			submitForm(){
				this.error = {
					card_number: '',
					exp_date: '',
					cvv: '',
					name: ''
				}
				this.push = {
					loading: true,
					error: {},
					otp_url:false
				}
				
				if(this.is_expired_trx){
					this.toggleExpired
					this.setBeTxPayment({})
				}else{
					if(this.is_international) this.submitCreatePaymentMethod()
					else this.submitCreateToken()
				}
			},
			submitCreateToken(){
				if(!this.validateForm()){
					this.push = {
						loading: false,
						error: {},
						otp_url:false
					}
				}else{
					let exp_date = this.form.exp_date.split("/")
					let params = {
						amount: this.tx_payment.amount,
						card_number: this.form.card_number.replace(/\D/g,''),
						card_exp_month: exp_date[0],
						card_exp_year: exp_date[1],
						card_cvn: this.form.cvv,
						is_multiple_use: false,
						should_authenticate: true,
						currency: this.tx_payment.currency,
						card_holder_first_name: this.form.first_name,
						card_holder_last_name: this.form.last_name,
						card_holder_email: this.$removeWhiteSpace(this.form.email),
						card_holder_phone_number: this.$removeWhiteSpace(this.form.phone_number),
					}
					
					let allowed_module = this.module_page == 'BOOKING_ENGINE' || this.module_page == 'TICKET' || this.module_page == 'RESTAURANT' || this.module_page == 'CONCIERGE_RESERVATION' || this.module_page == 'UPSELLING' || this.module_page == 'CONCIERGE'
					if(allowed_module && this.tx_payment.use_guestpro_pg){
						params.on_behalf_of = this.tx_payment.on_behalf_of
					}
					
					let self = this
					Xendit.setPublishableKey(this.tx_payment.public_key)
					Xendit.card.createToken(params, function (err, data) {
						if (err) {
							self.push.error = err
							self.push.loading = false
						}else{
							if (data.status === 'VERIFIED') {
								self.captureCC(data)
							} else if (data.status === 'IN_REVIEW') {
								window.open(data.payer_authentication_url, 'sample-inline-frame');
								self.push.loading = false
								self.push.is_otp = true
							} else if (data.status === 'FAILED') {
								self.push.error = {
									error_code: 'PAYMENT FAILED',
									message: data.failure_reason 
								}
								self.push.loading = false
								self.push.is_otp = false
							}
						}
					});
				}
			},
			submitCreatePaymentMethod(){
				if(!this.validateForm()){
					this.push = {
						loading: false,
						error: {},
						otp_url:false
					}
				}else{
					let exp_date = this.form.exp_date.split("/")
					let redirect_url = `${window.location.origin}/${this.getMerchant().code}/be/payment-result/${this.tx_payment.tx_order_id}`
          const { card_number, cvv, first_name, last_name, email, phone_number  } = this.form;
          
					let params = {
						type: 'CARD',
						card: {
							currency: this.tx_payment.currency,
							channel_properties: {
								success_return_url: redirect_url,
								failure_return_url: redirect_url,
							},
							card_information: {
								card_number: card_number.replace(/\D/g,''),
								expiry_month: exp_date[0], 
								expiry_year: exp_date[1], 
								cvv, 
                cardholder_name: `${first_name}${this.$isEmpty(last_name) ? '' : ' '+last_name}`,
                cardholder_email: email,
                cardholder_phone_number: phone_number 
							},
						},
						reusability: 'ONE_TIME_USE',
					}
	
					let self = this
					Xendit.setPublishableKey(this.tx_payment.public_key);
					Xendit.payment.createPaymentMethod(params, function (err, data) {
						if (err) {
							let { error_code, message } = err
							self.push.loading = false
							if(error_code = 'VALIDATION_ERROR'){
								if(message == 'Card number is invalid') self.error.card_number = 'Invalid card number'
								else if(message == 'Card expiration date is invalid') self.error.exp_date = 'Invalid expiry date'
								else if(message == 'Card cvn  is invalid') self.error.cvv = 'Invalid CVV'
								else {
									self.push.error = err
								}
							}else{
								self.push.error = err
							}
						}else{
							self.captureCC(data)
						}
					});
				}
			},
			captureCC(data){
				this.push = {
					loading: true,
					error: {},
					otp_url: false
				}
				let params = {
					amount: this.tx_payment.amount,
					token: data.id
				}
				if(this.is_international){
					params.ref_id = this.tx_payment.reference_id
					params.pgc_id = this.tx_payment.payment_method.id
					params.mc_id = this.getMerchant().id
				}else{
					params.reference_id = this.tx_payment.reference_id
				}
				let xendit_url = this.is_international ? 'xendit-international' : 'xendit'
				post("BASE",`${xendit_url}/cc/capture-charge`, params).then(response=>{
					if(this.is_international){
						if(response.data.error_code){
							this.push.error = {
								error_code: response.data.error_code,
								message: response.data.message
							}
						}else{
							this.$emit('done-destroyed')
							this.setBeTxPayment({})
							this.$openLink(response.data.actions[0].url)
						}
					}else{
						if(response.data.success){
							this.$emit("done")
							if(this.module_page == 'BOOKING_ENGINE'){
                this.setBeTxPayment({})
                
                let routeDetail = {
                  name: 'BePaymentResult',
                  params:{
                    tx_order_id : this.tx_payment.tx_order_id
                  }
                }
                if(this.submodule_page === 'BE_ADDITIONAL_SERVICE'){
                  routeDetail = {
                    params: {
                      tx_order_id: this.tx_payment.tx_order_id_2
                    },
                    query: {
                      module: "additional-service"
                    }
                  }
                }else{
                  if(this.$isNotEmptyV2(this.tx_payment.tx_sk)){
                    routeDetail.query = {
                      tx_sk: this.tx_payment.tx_sk
                    }
                  }
                }
                
                this.$router.push(routeDetail)
							}else if(this.module_page == 'CONCIERGE'){
								if(this.submodule_page == 'CUSTOM_POS'){
									this.$router.push({
										name: 'PosPaymentResult',
										params:{
											merchant_code: this.getMerchant().code,
											pos_code: this.tx_payment.general_data.code,
											tx_order_id : this.tx_payment.tx_order_id_2
										}
									})	
								}else{
									this.$router.push({
										name: 'BeModuleServiceTrxResult',
										params:{
											merchant_code: this.getMerchant().code,
											trx_id : this.tx_payment.tx_order_id_2
										}
									})
								}
							}else if(this.module_page == 'CONCIERGE_RESERVATION'){
								this.$router.push({
									name: 'PaymentBillResultHotel',
									params:{
										merchant_code: this.getMerchant().code,
										ga_reservation_id: this.tx_payment.reservation.id,
										tx_payment_id: this.tx_payment.tx_order_id
									}
								})
							}else if(this.module_page == 'CONCIERGE'){
								this.$router.push({
									name: 'GroupVoucherBookingResult',
									params:{
										merchant_code: this.getMerchant().code,
										tx_order_id : this.tx_payment.tx_order_id_2
									}
								})
							}else if(this.module_page == 'RESTAURANT'){
								if(this.submodule_page == 'BILL'){
									this.$router.push({
										name: 'RestaurantPaymentResult',
										params:{
											merchant_code: this.getMerchant().code,
											tx_payment_id : this.tx_payment.tx_order_id_2
										}
									})
								}else{
									this.$router.push({
										name: 'RestaurantTrxResult',
										params:{
											merchant_code: this.getMerchant().code,
											trx_id : this.tx_payment.tx_order_id
										}
									})
								}
							}else if(this.module_page == 'TICKET'){
								this.$router.push({
									name: 'TicketPaymentForm',
									params:{
										merchant_code: this.getMerchant().code,
										tx_order_id : this.tx_payment.tx_order_id
									}
								})
							}else{
								console.log("DONE")
							}
						}else{
							if(response.data.failure_reason){
								this.push.error = {
									error_code: 'PAYMENT FAILED',
									message: this.parsingErrorMessage(response.data.failure_reason),
									xendit_code: response.data.failure_reason
								}	
							}else{
								this.push.error = {
									error_code: 'PAYMENT FAILED',
									message: response.data.message,
								}
							}
						}
					}
										
					this.push.loading = false
				})
			},
			parsingErrorMessage(responseCode = ''){
				let official_message = [
					{
						"code": ["AUTHENTICATION_FAILED", "AUTHENTICATION_REJECTED"],
						"message": "The payment has not been authenticated. Please re-authenticate the transaction with 3DS, or use a different card."
					},
					{
						"code": ["DECLINED_BY_ISSUER"],
						"message": "The payment was declined by the issuer with no additional information. Please contact your card issuing bank or use a different card."
					},
					{
						"code": ["DECLINED_BY_PROCESSOR"],
						"message": "The payment was declined by the processor without additional information. Please try again or use a different payment method."
					},
					{
						"code": ["EXPIRED_CARD"],
						"message": "The payment was declined because the card has expired. Please check the expiration date or contact your bank."
					},
					{
						"code": ["FRAUD_RISK_BLOCKED"],
						"message": "The payment was blocked due to fraud risk. If you believe this is an error, remove the blocklist identifier and try again."
					},
					{
						"code": ["INACTIVE_OR_UNAUTHORIZED_CARD"],
						"message": "The payment was declined because the card is not authorized for online transactions. Please contact your bank."
					},
					{
						"code": ["INSUFFICIENT_BALANCE"],
						"message": "The payment was declined due to insufficient funds. Please ensure you have enough balance or contact your bank."
					},
					{
						"code": ["INVALID_CARD"],
						"message": "The payment was declined due to incorrect card information. Please review and try again."
					},
					{
						"code": ["INVALID_CVV"],
						"message": "The payment was declined due to an incorrect CVV. Please check and try again."
					},
					{
						"code": ["ISSUER_SUSPECT_FRAUD"],
						"message": "The payment was declined due to suspected fraud. If the cardholder is legitimate, try using a different card."
					},
					{
						"code": ["ISSUER_UNAVAILABLE"],
						"message": "The payment was declined because the card issuer is unreachable. Please contact your bank."
					},
					{
						"code": ["PROCESSOR_ERROR"],
						"message": "The payment was declined due to an intermittent processor error. Please try again later."
					},
					{
						"code": ["PROCESSOR_TIMEOUT"],
						"message": "The payment was declined due to a timeout. Check your balance and try again."
					},
					{
						"code": ["STOLEN_CARD"],
						"message": "The payment was declined because the card was reported as stolen. If legitimate, try using a different card."
					}
				]

				let selected_message = official_message.find(error => error.code.some(code => code == responseCode))
				return selected_message ? selected_message.message : code
			},
			cancelForm(){
				this.cancel = {
					loading: true,
					error: ''
				}

				if(this.module_page == 'CONCIERGE_RESERVATION'){
					let {pms_detail_id,folio_number} = this.tx_payment.reservation
					this.$router.push(`${this.getMerchant().code}/payment_bill/${pms_detail_id}?src=gp-pms&folio=${folio_number}`)
				}else{
					let api_url = ''
					let api_module = 'CORE_HOTEL'
					if(this.module_page == 'BOOKING_ENGINE'){
            if(this.submodule_page === 'BE_ADDITIONAL_SERVICE'){
  						api_url = `merchant-pos/multiple/transaction/${this.tx_payment.tx_order_id_2}/cancel-transaction`
            }else{
              api_url = `tx-detail/${this.tx_payment.tx_order_id}/cancel-payment`
            }
					}else if(this.module_page == 'UPSELLING'){
						api_url = `merchant-pos/multiple/transaction/${this.tx_payment.tx_order_id_2}/cancel-transaction`
					}else if(this.module_page == 'CONCIERGE'){
						api_url = `merchant-pos/transaction/${this.tx_payment.tx_order_id_2}/cancel-transaction`
					}else if(this.module_page == 'RESTAURANT'){
						api_module = 'CORE_RESTO'
						if(this.submodule_page == 'BILL'){
							api_url = `v2/tx-history/${this.tx_payment.tx_order_id}/cancel-transaction`
						}else{
							console.log("ON PROGRESS")
						}
					}else if(this.module_page == 'TICKET'){
						api_module = 'CORE'
						api_url = `tx-ticket-detail/${this.tx_payment.tx_order_id}/cancel-transaction`
					}
	
					post(api_module,`${api_url}?merchant_id=${this.getMerchant().id}`).then(response=>{
						let res = response.data
						if(res.success){
							this.$emit("done-destroyed")
							if(this.module_page == 'BOOKING_ENGINE'){
                if(this.submodule_page !== 'BE_ADDITIONAL_SERVICE'){
                  this.setBeTxPayment({})
                  this.$router.push({
                    name: 'BePaymentResult',
                    params:{
                      tx_order_id : this.tx_payment.tx_order_id
                    },
                    query: {
                      tx_sk: this.tx_payment.tx_sk
                    }
                  })
                }
							}else if(this.module_page == 'CONCIERGE'){
								if(this.submodule_page == 'CUSTOM_POS'){
									this.$router.push({
										name: 'PosPaymentResult',
										params:{
											merchant_code: this.getMerchant().code,
											pos_code: this.tx_payment.general_data.code,
											tx_order_id : this.tx_payment.tx_order_id_2
										}
									})	
								}else{
									this.$router.push({
										name: 'BeModuleServiceTrxResult',
										params:{
											merchant_code: this.getMerchant().code,
											trx_id : this.tx_payment.tx_order_id_2
										}
									})
								}
							}else if(this.module_page == 'UPSELLING'){
								this.$router.push({
									name: 'GroupVoucherBookingResult',
									params:{
										merchant_code: this.getMerchant().code,
										tx_order_id : this.tx_payment.tx_order_id_2
									}
								})
							}else if(this.module_page == 'RESTAURANT'){
								if(this.submodule_page == 'BILL'){
									this.$router.push({
										name: 'MerchantHome',
										params:{
											merchant_code: this.getMerchant().code
										}
									})
								}else{
									this.$router.push({
										name: 'RestaurantTrxResult',
										params:{
											merchant_code: this.getMerchant().code,
											trx_id : this.tx_payment.tx_order_id
										}
									})
								}
							}else if(this.module_page == 'TICKET'){
								this.$router.push({
									name: 'TicketPaymentForm',
									params:{
										merchant_code: this.getMerchant().code,
										tx_order_id : this.tx_payment.tx_order_id
									}
								})
							}
						}else{
							this.cancel.errror = res.message
						}
						this.cancel.loading = false
					})
				}

			}
		}
	}
</script>
<style scoped>
  .box-warning{
    position: fixed;
    height: 100vh;
    width: 100%;
    z-index: 9999;
    top: 0;
    left: 0;
    bottom: 0;
  }
  .background-warning{
    background-color: rgba(0,0,0,.8)!important;
  }
  .text-black{
    color:#000 !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/XenditInputCC.vue